<main class="unsubscribe">
  <div class="unsubscribe__container" aria-live="polite">
    @switch (status()) {
      @case ('pending') {
        <p class="unsubscribe__loading" role="status">
          Cancelando tu alerta…
        </p>
      }
      @case ('success') {
        <div class="unsubscribe__panel">
          <img
            class="unsubscribe__mascot"
            src="/images/logo/cart_success.png"
            alt=""
            loading="lazy"
          />
          <h1 class="unsubscribe__title">Listo, alerta cancelada</h1>
          <p class="unsubscribe__subtitle">
            Ya no recibirás correos sobre el stock de este producto.
          </p>
          <app-button variant="primary" routerLink="/tienda">
            Seguir explorando
          </app-button>
        </div>
      }
      @case ('not_found') {
        <div class="unsubscribe__panel">
          <img
            class="unsubscribe__mascot"
            src="/images/logo/404.png"
            alt=""
            loading="lazy"
          />
          <h1 class="unsubscribe__title">Enlace no válido</h1>
          <p class="unsubscribe__subtitle">
            Este enlace ya fue usado o expiró. Si sigues recibiendo correos, avísanos desde contacto.
          </p>
          <app-button variant="primary" routerLink="/tienda">
            Volver a la tienda
          </app-button>
        </div>
      }
      @case ('error') {
        <div class="unsubscribe__panel">
          <h1 class="unsubscribe__title">Algo salió mal</h1>
          <p class="unsubscribe__subtitle">
            No pudimos cancelar la alerta. Intenta de nuevo en unos segundos.
          </p>
          <app-button variant="primary" (click)="retry()">
            Reintentar
          </app-button>
        </div>
      }
    }
  </div>
</main>
